(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["board-game-filters"] && !Shopify.designMode) return;
  try {
    function initializeBoardGameFilters() {
    document.querySelectorAll('[data-board-game-filter-ui]').forEach((root) => {
      root.querySelectorAll('[data-board-game-tag-link]').forEach((link) => {
        const targetUrl = new URL(link.getAttribute('href'), window.location.origin);
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.forEach((value, key) => {
          if (!targetUrl.searchParams.has(key)) targetUrl.searchParams.append(key, value);
        });
        link.href = targetUrl.toString();
      });

      const search = root.querySelector('[data-publisher-search]');
      if (search && !search.dataset.initialized) {
        search.dataset.initialized = 'true';
        search.addEventListener('input', () => {
          const query = search.value.trim().toLowerCase();
          root.querySelectorAll('[data-publisher-item]').forEach((item) => {
            item.hidden = query.length > 0 && !item.textContent.toLowerCase().includes(query);
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBoardGameFilters);
  } else {
    initializeBoardGameFilters();
  }
  document.addEventListener('shopify:section:load', initializeBoardGameFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paint-color-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paint-color-finder')) {
  customElements.define('paint-color-finder', class extends HTMLElement {
    connectedCallback() {
      this.index = [];
      window.__lionheartProductPromises = window.__lionheartProductPromises || new Map();
      this.dialog = this.querySelector('dialog');
      this.openButton = this.previousElementSibling?.matches('[data-pcf-open]') ? this.previousElementSibling : null;
      this.closeButton = this.querySelector('[data-pcf-close]');
      this.canvas = this.querySelector('.paint-finder__wheel');
      this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
      this.standardCanvas = this.querySelector('.paint-finder__standard-square');
      this.standardCtx = this.standardCanvas.getContext('2d');
      this.hueCanvas = this.querySelector('.paint-finder__hue-strip');
      this.hueCtx = this.hueCanvas.getContext('2d');
      this.brightness = this.querySelector('.paint-finder__brightness');
      this.hexInput = this.querySelector('.paint-finder__hex');
      this.nativeInput = this.querySelector('.paint-finder__native');
      this.preview = this.querySelector('.paint-finder__preview');
      this.flatPicker = this.querySelector('[data-pcf-flat-picker]');
      this.productShiftPreview = this.querySelector('[data-pcf-product-shift-preview]');
      this.productShiftStage = this.querySelector('[data-pcf-product-shift-stage]');
      this.productShiftSphere = this.querySelector('[data-pcf-product-shift-sphere]');
      this.productShiftColors = this.querySelector('[data-pcf-product-shift-colors]');
      this.productShiftRequirement = this.querySelector('[data-pcf-product-shift-requirement]');
      this.shiftGenerator = this.querySelector('[data-pcf-shift-generator]');
      this.shiftStage = this.querySelector('[data-pcf-shift-stage]');
      this.shiftSphere = this.querySelector('[data-pcf-shift-sphere]');
      this.shiftPreviewLabel = this.querySelector('[data-pcf-shift-preview-label]');
      this.shiftRequirement = this.querySelector('[data-pcf-shift-requirement]');
      this.shiftStartInput = this.querySelector('[data-pcf-shift-start]');
      this.shiftEndInput = this.querySelector('[data-pcf-shift-end]');
      this.shiftStartOutput = this.querySelector('[data-pcf-shift-start-output]');
      this.shiftEndOutput = this.querySelector('[data-pcf-shift-end-output]');
      this.shiftSwap = this.querySelector('[data-pcf-shift-swap]');
      this.shiftAngleInput = this.querySelector('[data-pcf-shift-angle]');
      this.shiftAngleOutput = this.querySelector('[data-pcf-shift-angle-output]');
      this.closestPreview = this.querySelector('.paint-finder__closest-preview');
      this.closestCaption = this.querySelector('.paint-finder__match-caption');
      this.closestName = this.querySelector('.paint-finder__closest-name');
      this.closestEntry = null;
      this.stock = this.querySelector('.paint-finder__stock');
      this.stockCheck = this.querySelector('.paint-finder__stock-check');
      this.lookupBrand = this.querySelector('.paint-finder__lookup-brand');
      this.lookupInput = this.querySelector('.paint-finder__lookup-input');
      this.lookupButton = this.querySelector('.paint-finder__lookup-button');
      this.lookupOptions = this.querySelector('.paint-finder__lookup-options');
      this.lookupStatus = this.querySelector('.paint-finder__lookup-status');
      this.lookupSourceHandle = '';
      this.sourceTabs = [...this.querySelectorAll('.paint-finder__source-tab')];
      this.sourcePanels = [...this.querySelectorAll('.paint-finder__source-panel')];
      this.pickerStyleTabs = [...this.querySelectorAll('.paint-finder__picker-tab')];
      this.pickerStylePanels = [...this.querySelectorAll('.paint-finder__picker-panel')];
      this.pickerMode = this.readPickerPreference();
      this.modeInputs = [...this.querySelectorAll('.paint-finder__mode')];
      this.chemistryInputs = [...this.querySelectorAll('.paint-finder__chemistry')];
      this.applicationInputs = [...this.querySelectorAll('.paint-finder__application')];
      this.filterSections = [...this.querySelectorAll('[data-pcf-filter-section]')];
      this.filterValues = new Map([...this.querySelectorAll('[data-pcf-filter-value]')].map(element => [element.dataset.pcfFilterValue, element]));
      this.mobileFilterQuery = window.matchMedia('(max-width: 430px)');
      this.brandInputs = [...this.querySelectorAll('.paint-finder__brands input')];
      this.brandSummary = this.querySelector('.paint-finder__brand-summary');
      this.selectAllBrandsButton = this.querySelector('[data-pcf-brands-all]');
      this.deselectAllBrandsButton = this.querySelector('[data-pcf-brands-none]');
      this.results = this.querySelector('.paint-finder__results');
      this.resultsTitle = this.querySelector('[data-pcf-results-title]');
      this.status = this.querySelector('.paint-finder__status');
      this.indexPromise = this.loadIndex();
      this.hsv = this.hexToHsv(this.dataset.sourceHex || '#808080');
      this.setInitialFilters();
      this.setupFilterSections();
      this.updateFilterSummaries();
      this.brightness.value = Math.round(this.hsv.v * 100);
      this.bind();
      this.setupSampling();
      this.activatePickerStyle(this.pickerMode);
      this.updateModeInterface();
      this.applyColor(this.dataset.sourceHex || '#808080', false);
      if (!this.dialog) this.scheduleSearch();
    }

    setupSampling() {
      this.samplingPanel = this.querySelector('[data-pcf-sampling]');
      if (!this.samplingPanel) return;
      this.photoInput = this.querySelector('[data-pcf-photo-input]');
      this.cameraPhotoInput = this.querySelector('[data-pcf-camera-photo-input]');
      this.choosePhotoButton = this.querySelector('[data-pcf-choose-photo]');
      this.cameraButton = this.querySelector('[data-pcf-use-camera]');
      this.screenDropperButton = this.querySelector('[data-pcf-screen-dropper]');
      this.sampleCanvas = this.querySelector('[data-pcf-sample-canvas]');
      this.sampleContext = this.sampleCanvas.getContext('2d', { willReadFrequently: true });
      this.photoStage = this.querySelector('[data-pcf-photo-stage]');
      this.photoReticle = this.querySelector('[data-pcf-photo-reticle]');
      this.photoHelp = this.querySelector('[data-pcf-photo-help]');
      this.cameraArea = this.querySelector('[data-pcf-camera-area]');
      this.cameraVideo = this.querySelector('[data-pcf-camera-video]');
      this.cameraMatchButton = this.querySelector('[data-pcf-camera-match]');
      this.cameraStopButton = this.querySelector('[data-pcf-camera-stop]');
      this.samplingStatus = this.querySelector('[data-pcf-sampling-status]');
      this.samplingShiftHelp = this.querySelector('[data-pcf-sampling-shift-help]');
      this.samplingPhotoToken = this.samplingPhotoToken || 0;
      this.samplingCameraToken = this.samplingCameraToken || 0;
      this.cameraPhotoFallback = !navigator.mediaDevices?.getUserMedia || !window.isSecureContext;
      this.cameraButton.textContent = this.samplingLabel(this.cameraPhotoFallback ? 'takePhotoLabel' : 'cameraLabel');
      this.screenDropperButton.hidden = typeof window.EyeDropper !== 'function';
      if (!this.samplingBound) {
        this.samplingBound = true;
        this.choosePhotoButton.addEventListener('click', () => this.openSamplingPhotoPicker(this.photoInput));
        this.cameraButton.addEventListener('click', () => {
          if (this.cameraPhotoFallback) this.openSamplingPhotoPicker(this.cameraPhotoInput);
          else this.startSamplingCamera();
        });
        [this.photoInput, this.cameraPhotoInput].forEach(input => input.addEventListener('change', () => {
          const file = input.files?.[0];
          if (file) this.loadSamplingPhoto(file);
        }));
        this.screenDropperButton.addEventListener('click', () => this.pickScreenColor());
        this.cameraMatchButton.addEventListener('click', () => this.captureSamplingCamera());
        this.cameraStopButton.addEventListener('click', () => {
          this.stopSamplingCamera();
          this.samplingStatus.textContent = this.samplingLabel('cameraStopped');
        });
        this.samplingPanel.addEventListener('toggle', () => {
          if (!this.samplingPanel.open) this.suspendSampling();
          else this.updatePhotoReticle();
        });
        this.sampleCanvas.addEventListener('click', event => {
          const point = this.samplingPhotoPoint(event.clientX, event.clientY);
          if (!point) return;
          this.sampleCanvas.focus({ preventScroll: true });
          this.samplePhotoAt(point.x, point.y);
        });
        this.sampleCanvas.addEventListener('keydown', event => {
          if (!this.samplingPhoto) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.samplePhotoAt(this.samplingPoint.x, this.samplingPoint.y);
            return;
          }
          const directions = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
          if (!directions[event.key]) return;
          event.preventDefault();
          const step = Math.max(1, Math.round(Math.min(this.sampleCanvas.width, this.sampleCanvas.height) / 100)) * (event.shiftKey ? 5 : 1);
          this.samplingPoint.x = Math.max(0, Math.min(this.sampleCanvas.width - 1, this.samplingPoint.x + directions[event.key][0] * step));
          this.samplingPoint.y = Math.max(0, Math.min(this.sampleCanvas.height - 1, this.samplingPoint.y + directions[event.key][1] * step));
          this.updatePhotoReticle();
        });
        this.dialog?.addEventListener('close', () => this.suspendSampling());
        this.dialog?.addEventListener('cancel', () => this.suspendSampling());
        this.samplingVisibilityHandler = () => { if (document.visibilityState === 'hidden') this.suspendSampling(); };
        this.samplingPageHideHandler = () => this.suspendSampling();
        this.samplingResizeHandler = () => this.updatePhotoReticle();
      }
      document.addEventListener('visibilitychange', this.samplingVisibilityHandler);
      window.addEventListener('pagehide', this.samplingPageHideHandler);
      window.addEventListener('resize', this.samplingResizeHandler);
      this.samplingResizeObserver?.disconnect();
      if (typeof ResizeObserver === 'function') {
        this.samplingResizeObserver = new ResizeObserver(() => this.updatePhotoReticle());
        this.samplingResizeObserver.observe(this.sampleCanvas);
      }
    }

    disconnectedCallback() {
      this.suspendSampling();
      this.samplingResizeObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.samplingVisibilityHandler);
      window.removeEventListener('pagehide', this.samplingPageHideHandler);
      window.removeEventListener('resize', this.samplingResizeHandler);
    }

    samplingLabel(key) {
      return this.samplingPanel?.dataset[`pcfSampling${key[0].toUpperCase()}${key.slice(1)}`] || '';
    }

    samplingIsActive() {
      return this.isConnected && this.samplingPanel?.open && !this.querySelector('[data-pcf-panel="picker"]').hidden && (!this.dialog || this.dialog.open) && document.visibilityState !== 'hidden';
    }

    openSamplingPhotoPicker(input) {
      this.suspendSampling();
      input.value = '';
      input.click();
    }

    async loadSamplingPhoto(file) {
      this.stopSamplingCamera();
      this.samplingScreenController?.abort();
      const token = ++this.samplingPhotoToken;
      if (!this.samplingIsActive()) return;
      if (file.size > 25 * 1024 * 1024) {
        this.samplingStatus.textContent = this.samplingLabel('photoLarge');
        return;
      }
      if ((file.type && !file.type.startsWith('image/')) || file.type === 'image/svg+xml' || /\.svgz?$/i.test(file.name)) {
        this.samplingStatus.textContent = this.samplingLabel('photoInvalid');
        return;
      }
      this.samplingStatus.textContent = this.samplingLabel('photoLoading');
      const image = new Image();
      const url = URL.createObjectURL(file);
      this.samplingPhotoUrl = url;
      try {
        await new Promise((resolve, reject) => {
          image.onload = resolve;
          image.onerror = reject;
          image.src = url;
        });
        if (token !== this.samplingPhotoToken || !this.samplingIsActive()) return;
        if (!image.naturalWidth || !image.naturalHeight) throw new Error('Invalid image dimensions');
        if (image.naturalWidth * image.naturalHeight > 80000000) {
          this.samplingStatus.textContent = this.samplingLabel('photoLarge');
          return;
        }
        this.setSamplingPhoto(image, image.naturalWidth, image.naturalHeight);
        this.samplingStatus.textContent = this.samplingLabel('photoReady');
      } catch (error) {
        if (token === this.samplingPhotoToken && this.samplingIsActive()) this.samplingStatus.textContent = this.samplingLabel('photoInvalid');
      } finally {
        image.onload = null;
        image.onerror = null;
        image.src = '';
        URL.revokeObjectURL(url);
        if (this.samplingPhotoUrl === url) this.samplingPhotoUrl = null;
      }
    }

    setSamplingPhoto(source, width, height) {
      const scale = Math.min(1, 2048 / Math.max(width, height));
      this.sampleCanvas.width = Math.max(1, Math.round(width * scale));
      this.sampleCanvas.height = Math.max(1, Math.round(height * scale));
      this.sampleContext.clearRect(0, 0, this.sampleCanvas.width, this.sampleCanvas.height);
      this.sampleContext.drawImage(source, 0, 0, this.sampleCanvas.width, this.sampleCanvas.height);
      this.samplingPhoto = true;
      this.samplingPoint = { x: Math.floor(this.sampleCanvas.width / 2), y: Math.floor(this.sampleCanvas.height / 2) };
      this.photoStage.hidden = false;
      this.photoHelp.hidden = false;
      this.photoReticle.hidden = false;
      requestAnimationFrame(() => this.updatePhotoReticle());
    }

    samplingPhotoRect() {
      const rect = this.sampleCanvas.getBoundingClientRect();
      const scale = Math.min(rect.width / this.sampleCanvas.width, rect.height / this.sampleCanvas.height);
      if (!scale) return null;
      const width = this.sampleCanvas.width * scale;
      const height = this.sampleCanvas.height * scale;
      return { left: rect.left + (rect.width - width) / 2, top: rect.top + (rect.height - height) / 2, width, height, scale };
    }

    samplingPhotoPoint(clientX, clientY) {
      if (!this.samplingPhoto) return null;
      const rect = this.samplingPhotoRect();
      if (!rect || clientX < rect.left || clientX >= rect.left + rect.width || clientY < rect.top || clientY >= rect.top + rect.height) return null;
      return { x: Math.floor((clientX - rect.left) / rect.scale), y: Math.floor((clientY - rect.top) / rect.scale) };
    }

    updatePhotoReticle() {
      if (!this.samplingPhoto || this.photoStage.hidden) return;
      const rect = this.samplingPhotoRect();
      if (!rect) return;
      const stageRect = this.photoStage.getBoundingClientRect();
      this.photoReticle.style.left = `${rect.left - stageRect.left - this.photoStage.clientLeft + (this.samplingPoint.x + .5) * rect.scale}px`;
      this.photoReticle.style.top = `${rect.top - stageRect.top - this.photoStage.clientTop + (this.samplingPoint.y + .5) * rect.scale}px`;
    }

    samplePhotoAt(x, y) {
      if (!this.samplingPhoto || !this.samplingIsActive()) return;
      x = Math.max(0, Math.min(this.sampleCanvas.width - 1, Math.round(x)));
      y = Math.max(0, Math.min(this.sampleCanvas.height - 1, Math.round(y)));
      this.samplingPoint = { x, y };
      this.updatePhotoReticle();
      const left = Math.max(0, x - 1);
      const top = Math.max(0, y - 1);
      const right = Math.min(this.sampleCanvas.width - 1, x + 1);
      const bottom = Math.min(this.sampleCanvas.height - 1, y + 1);
      const pixels = this.sampleContext.getImageData(left, top, right - left + 1, bottom - top + 1).data;
      const totals = [0, 0, 0];
      let weight = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        const alpha = pixels[i + 3] / 255;
        if (!alpha) continue;
        weight += alpha;
        for (let channel = 0; channel < 3; channel++) totals[channel] += pixels[i + channel] * alpha;
      }
      if (!weight) {
        this.samplingStatus.textContent = this.samplingLabel('photoTransparent');
        return;
      }
      const hex = '#' + totals.map(value => Math.round(value / weight).toString(16).padStart(2, '0')).join('').toUpperCase();
      this.useSampledColor(hex);
    }

    useSampledColor(hex) {
      const normalized = this.normalizeHex(hex);
      if (!normalized) return;
      this.lookupSourceHandle = '';
      this.hsv = this.hexToHsv(normalized);
      this.brightness.value = Math.round(this.hsv.v * 100);
      this.hexInput.setCustomValidity('');
      this.activateSourceTab('picker');
      if (this.selectedMode() === 'color_shift') {
        this.shiftStartInput.value = normalized;
        this.updateShiftPreview();
      }
      this.applyColor(normalized);
      this.samplingStatus.textContent = this.samplingLabel('sampled').replace('__HEX__', normalized.toUpperCase());
    }

    async startSamplingCamera() {
      this.suspendSampling();
      if (!this.samplingIsActive()) return;
      const token = ++this.samplingCameraToken;
      this.cameraButton.disabled = true;
      this.cameraArea.hidden = false;
      this.photoStage.hidden = true;
      this.photoHelp.hidden = true;
      this.cameraMatchButton.disabled = true;
      this.samplingStatus.textContent = this.samplingLabel('cameraStarting');
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } } });
        if (token !== this.samplingCameraToken || !this.samplingIsActive()) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        this.samplingCameraStream = stream;
        this.cameraVideo.srcObject = stream;
        await this.cameraVideo.play();
        if (token !== this.samplingCameraToken || !this.samplingIsActive()) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        if (!this.cameraVideo.videoWidth || !this.cameraVideo.videoHeight) throw new Error('Camera video unavailable');
        this.cameraMatchButton.disabled = false;
        this.samplingStatus.textContent = this.samplingLabel('cameraReady');
        stream.getVideoTracks().forEach(track => track.addEventListener('ended', () => {
          if (token !== this.samplingCameraToken) return;
          this.stopSamplingCamera();
          this.samplingStatus.textContent = this.samplingLabel('cameraStopped');
        }, { once: true }));
      } catch (error) {
        stream?.getTracks().forEach(track => track.stop());
        if (token !== this.samplingCameraToken) return;
        this.stopSamplingCamera();
        this.cameraPhotoFallback = true;
        this.cameraButton.textContent = this.samplingLabel('takePhotoLabel');
        this.samplingStatus.textContent = this.samplingLabel('cameraUnavailable');
      } finally {
        if (token === this.samplingCameraToken) this.cameraButton.disabled = false;
      }
    }

    captureSamplingCamera() {
      if (!this.samplingCameraStream || !this.samplingIsActive() || !this.cameraVideo.videoWidth || this.cameraMatchButton.disabled) return;
      try {
        this.setSamplingPhoto(this.cameraVideo, this.cameraVideo.videoWidth, this.cameraVideo.videoHeight);
        this.stopSamplingCamera();
        this.samplePhotoAt(this.samplingPoint.x, this.samplingPoint.y);
        this.sampleCanvas.focus({ preventScroll: true });
      } catch (error) {
        this.stopSamplingCamera();
        this.samplingStatus.textContent = this.samplingLabel('cameraUnavailable');
      }
    }

    stopSamplingCamera() {
      this.samplingCameraToken = (this.samplingCameraToken || 0) + 1;
      this.samplingCameraStream?.getTracks().forEach(track => track.stop());
      this.samplingCameraStream = null;
      if (this.cameraVideo) {
        this.cameraVideo.pause();
        this.cameraVideo.srcObject = null;
      }
      if (this.cameraArea) this.cameraArea.hidden = true;
      if (this.cameraButton) this.cameraButton.disabled = false;
      if (this.cameraMatchButton) this.cameraMatchButton.disabled = true;
      if (this.photoStage) this.photoStage.hidden = !this.samplingPhoto;
      if (this.photoHelp) this.photoHelp.hidden = !this.samplingPhoto;
      this.updatePhotoReticle();
    }

    suspendSampling() {
      const cameraWasActive = this.samplingCameraStream || (this.cameraArea && !this.cameraArea.hidden);
      const photoWasLoading = this.samplingStatus?.textContent === this.samplingLabel('photoLoading');
      this.stopSamplingCamera();
      this.samplingPhotoToken = (this.samplingPhotoToken || 0) + 1;
      this.samplingScreenController?.abort();
      this.samplingScreenController = null;
      if (this.samplingPhotoUrl) {
        URL.revokeObjectURL(this.samplingPhotoUrl);
        this.samplingPhotoUrl = null;
      }
      if (cameraWasActive && this.samplingStatus) this.samplingStatus.textContent = this.samplingLabel('cameraStopped');
      else if (photoWasLoading && this.samplingStatus) this.samplingStatus.textContent = this.samplingPhoto ? this.samplingLabel('photoReady') : '';
    }

    async pickScreenColor() {
      if (typeof window.EyeDropper !== 'function') return;
      this.suspendSampling();
      if (!this.samplingIsActive()) return;
      const controller = new AbortController();
      this.samplingScreenController = controller;
      this.screenDropperButton.disabled = true;
      try {
        const result = await new window.EyeDropper().open({ signal: controller.signal });
        if (!controller.signal.aborted && this.samplingIsActive()) this.useSampledColor(result.sRGBHex);
      } catch (error) {
        if (error.name !== 'AbortError' && !controller.signal.aborted && this.samplingIsActive()) this.samplingStatus.textContent = this.samplingLabel('screenError');
      } finally {
        if (this.samplingScreenController === controller) this.samplingScreenController = null;
        this.screenDropperButton.disabled = false;
      }
    }

    async loadIndex() {
      const urls = [this.dataset.indexOverlayUrl, this.dataset.indexUrl, this.dataset.indexSupplementUrl].filter(Boolean);
      if (!urls.length) {
        this.indexError = true;
        return [];
      }
      if (!window.__lionheartPaintIndexPromise) {
        window.__lionheartPaintIndexPromise = Promise.all(urls.map(url =>
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(response => {
              if (!response.ok) throw new Error(`Paint index request failed: ${response.status}`);
              return response.json();
            })
            .then(data => Array.isArray(data) ? data : (data.paints || []))
        )).then(groups => {
          const seen = new Set();
          return groups.flat().filter(item => {
            const key = String(item.id || item.handle || '');
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
          });
        });
      }
      try {
        this.index = await window.__lionheartPaintIndexPromise;
        this.querySelectorAll('[data-pcf-index-count]').forEach(element => {
          element.textContent = this.index.length.toLocaleString();
        });
        this.addMissingBrandFilters();
        this.populateLookup();
        this.applyDeepLinkPaint();
        this.seedShiftGeneratorFromSource();
        this.renderProductShiftPreview();
        return this.index;
      } catch (error) {
        this.indexError = true;
        this.status.textContent = 'Paint index could not be loaded.';
        return [];
      }
    }

    applyDeepLinkPaint() {
      if (this.dialog) return;
      const handle = new URLSearchParams(window.location.search).get('source_paint');
      if (!handle || !/^[a-z0-9-]{1,150}$/.test(handle)) return;
      const selected = this.index.find(item => item.handle === handle);
      if (!selected || !this.normalizeHex(selected.hex)) return;
      this.lookupInput.value = this.paintName(selected);
      this.lookupSourceHandle = selected.handle;
      this.activateSourceTab('lookup');
      const mode = this.modeFor(selected);
      const modeInput = this.modeInputs.find(input => input.value === mode);
      if (modeInput) modeInput.checked = true;
      this.updateModeInterface();
      this.setChemistry(this.chemistryFor(selected));
      this.setApplication(this.applicationsFor(selected));
      this.updateFilterSummaries();
      this.hsv = this.hexToHsv(selected.hex);
      this.brightness.value = Math.round(this.hsv.v * 100);
      this.applyColor(selected.hex, false);
      if (mode === 'color_shift') this.seedShiftGeneratorFromSource(selected);
      this.lookupStatus.textContent = `Using ${this.paintName(selected)} by ${selected.brand}.`;
      this.scheduleSearch();
    }

    addMissingBrandFilters() {
      const fieldset = this.querySelector('.paint-finder__brands');
      if (!fieldset) return;
      const existing = new Set(this.brandInputs.map(input => input.value));
      const brands = [...new Set(this.index.map(item => item.brand).filter(Boolean))].sort((a, b) => a.localeCompare(b));
      brands.forEach(brand => {
        if (existing.has(brand)) return;
        const label = document.createElement('label');
        label.className = 'paint-finder__check';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.value = brand;
        input.checked = true;
        const span = document.createElement('span');
        span.textContent = brand;
        label.append(input, span);
        fieldset.append(label);
        input.addEventListener('change', () => {
          this.updateBrandSummary();
          this.scheduleSearch();
        });
        this.brandInputs.push(input);
      });
      this.updateBrandSummary();
    }

    populateLookup() {
      if (!this.lookupBrand || !this.lookupOptions) return;
      const currentBrand = this.lookupBrand.value || 'all';
      const brands = [...new Set(this.index.map(item => item.brand).filter(Boolean))].sort((a, b) => a.localeCompare(b));
      this.lookupBrand.replaceChildren(new Option('Any brand', 'all'), ...brands.map(brand => new Option(brand, brand)));
      this.lookupBrand.value = brands.includes(currentBrand) ? currentBrand : 'all';
      const selectedBrand = this.lookupBrand.value;
      const seen = new Set();
      const options = document.createDocumentFragment();
      this.index
        .filter(item => selectedBrand === 'all' || item.brand === selectedBrand)
        .sort((a, b) => this.paintName(a).localeCompare(this.paintName(b)) || String(a.brand).localeCompare(String(b.brand)))
        .forEach(item => {
          const label = this.paintName(item);
          const code = Array.isArray(item.skus) ? item.skus.find(Boolean) : item.sku;
          [label, code].filter(Boolean).forEach(value => {
            const key = this.normalizeLookup(value);
            if (!key || seen.has(key)) return;
            seen.add(key);
            const option = document.createElement('option');
            option.value = value;
            option.label = [item.brand, code && value !== code ? code : '', item.range].filter(Boolean).join(' · ');
            options.append(option);
          });
        });
      this.lookupOptions.replaceChildren(options);
    }

    setInitialFilters() {
      const sourceMode = this.dataset.sourceHandle ? this.modeFor({
          matchClass: this.dataset.sourceClass,
          finish: this.dataset.sourceFinish,
          paintType: this.dataset.sourcePaintType,
          range: this.dataset.sourceRange
        }) : 'all';
      const modeInput = this.modeInputs.find(input => input.value === sourceMode);
      if (modeInput) modeInput.checked = true;
      this.setChemistry(this.dataset.sourceChemistry);
      this.setApplication(this.dataset.sourceApplication);
    }

    bind() {
      this.sourceTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activateSourceTab(tab.dataset.pcfSource));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.sourceTabs.length) % this.sourceTabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.sourceTabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.sourceTabs.length - 1;
          this.activateSourceTab(this.sourceTabs[next].dataset.pcfSource);
          this.sourceTabs[next].focus();
        });
      });
      this.pickerStyleTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activatePickerStyle(tab.dataset.pcfPickerStyle));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.pickerStyleTabs.length) % this.pickerStyleTabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % this.pickerStyleTabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.pickerStyleTabs.length - 1;
          this.activatePickerStyle(this.pickerStyleTabs[next].dataset.pcfPickerStyle);
          this.pickerStyleTabs[next].focus();
        });
      });
      this.openButton?.addEventListener('click', () => {
        this.dialog.showModal();
        this.scheduleSearch();
        requestAnimationFrame(() => this.activePickerControl().focus());
      });
      this.closeButton?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('close', () => {
        this.openButton?.focus();
      });
      this.dialog?.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      });
      const bindPointer = (control, callback) => {
        control.addEventListener('pointerdown', event => {
          control.setPointerCapture(event.pointerId);
          callback(event);
        });
        control.addEventListener('pointermove', event => {
          if (control.hasPointerCapture(event.pointerId)) callback(event);
        });
      };
      bindPointer(this.canvas, event => this.pickFromPointer(event));
      bindPointer(this.standardCanvas, event => this.pickFromStandardPointer(event));
      bindPointer(this.hueCanvas, event => this.pickHueFromPointer(event));
      this.canvas.addEventListener('keydown', event => {
        const changes = { ArrowLeft: [-2, 0], ArrowRight: [2, 0], ArrowUp: [0, .02], ArrowDown: [0, -.02] };
        if (!changes[event.key]) return;
        event.preventDefault();
        this.hsv.h = (this.hsv.h + changes[event.key][0] + 360) % 360;
        this.hsv.s = Math.max(0, Math.min(1, this.hsv.s + changes[event.key][1]));
        this.applyColor(this.hsvToHex(this.hsv));
      });
      this.standardCanvas.addEventListener('keydown', event => {
        const changes = { ArrowLeft: [-.01, 0], ArrowRight: [.01, 0], ArrowUp: [0, .01], ArrowDown: [0, -.01] };
        if (!changes[event.key]) return;
        event.preventDefault();
        this.hsv.s = Math.max(0, Math.min(1, this.hsv.s + changes[event.key][0]));
        this.hsv.v = Math.max(0, Math.min(1, this.hsv.v + changes[event.key][1]));
        this.brightness.value = Math.round(this.hsv.v * 100);
        this.applyColor(this.hsvToHex(this.hsv));
      });
      this.hueCanvas.addEventListener('keydown', event => {
        const changes = { ArrowLeft: -2, ArrowRight: 2, ArrowUp: -2, ArrowDown: 2 };
        if (!changes[event.key]) return;
        event.preventDefault();
        this.hsv.h = (this.hsv.h + changes[event.key] + 360) % 360;
        this.applyColor(this.hsvToHex(this.hsv));
      });
      this.brightness.addEventListener('input', () => {
        this.hsv.v = Number(this.brightness.value) / 100;
        this.applyColor(this.hsvToHex(this.hsv));
      });
      this.hexInput.addEventListener('input', () => {
        this.hexInput.setCustomValidity('');
        const value = this.normalizeHex(this.hexInput.value);
        if (!value) return;
        this.hsv = this.hexToHsv(value);
        this.brightness.value = Math.round(this.hsv.v * 100);
        this.applyColor(value);
      });
      this.hexInput.addEventListener('change', () => {
        if (this.normalizeHex(this.hexInput.value)) return;
        this.hexInput.setCustomValidity('Enter a six-digit hexadecimal color.');
        this.hexInput.reportValidity();
      });
      this.nativeInput.addEventListener('input', () => {
        this.hsv = this.hexToHsv(this.nativeInput.value);
        this.brightness.value = Math.round(this.hsv.v * 100);
        this.applyColor(this.nativeInput.value);
      });
      this.lookupButton?.addEventListener('click', () => this.useLookupPaint());
      this.lookupInput?.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.useLookupPaint();
      });
      this.lookupBrand?.addEventListener('change', () => this.populateLookup());
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-pcf-add]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.addPaintToCart(button);
      });
      [this.stock, ...this.chemistryInputs, ...this.applicationInputs].forEach(control => control.addEventListener('change', () => {
        this.updateFilterSummaries();
        this.scheduleSearch();
      }));
      this.modeInputs.forEach(control => control.addEventListener('change', () => {
        this.updateModeInterface();
        this.updateFilterSummaries();
        this.scheduleSearch();
      }));
      [this.shiftStartInput, this.shiftEndInput].filter(Boolean).forEach(control => control.addEventListener('input', () => {
        this.updateShiftPreview();
        this.scheduleSearch();
      }));
      this.shiftSwap?.addEventListener('click', () => {
        const start = this.shiftStartInput.value;
        this.shiftStartInput.value = this.shiftEndInput.value;
        this.shiftEndInput.value = start;
        this.updateShiftPreview();
        this.scheduleSearch();
      });
      this.shiftAngleInput?.addEventListener('input', () => this.updateShiftPreview());
      this.brandInputs.forEach(control => control.addEventListener('change', () => {
        this.updateBrandSummary();
        this.scheduleSearch();
      }));
      this.selectAllBrandsButton?.addEventListener('click', () => this.setAllBrands(true));
      this.deselectAllBrandsButton?.addEventListener('click', () => this.setAllBrands(false));
      this.updateBrandSummary();
    }

    activateSourceTab(source) {
      if (source !== 'picker') this.suspendSampling();
      this.sourceTabs.forEach(tab => {
        const active = tab.dataset.pcfSource === source;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.sourcePanels.forEach(panel => {
        panel.hidden = panel.dataset.pcfPanel !== source;
      });
      if (source === 'picker') requestAnimationFrame(() => this.drawActivePicker());
    }

    readPickerPreference() {
      try {
        return window.sessionStorage.getItem('lionheart-paint-picker-style') === 'standard' ? 'standard' : 'wheel';
      } catch (error) {
        return 'wheel';
      }
    }

    activatePickerStyle(style) {
      this.pickerMode = style === 'standard' ? 'standard' : 'wheel';
      this.pickerStyleTabs.forEach(tab => {
        const active = tab.dataset.pcfPickerStyle === this.pickerMode;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.pickerStylePanels.forEach(panel => {
        panel.hidden = panel.dataset.pcfPickerPanel !== this.pickerMode;
      });
      try {
        window.sessionStorage.setItem('lionheart-paint-picker-style', this.pickerMode);
      } catch (error) {
      }
      this.drawActivePicker();
    }

    activePickerControl() {
      if (this.selectedMode() === 'color_shift') return this.shiftStartInput || this.canvas;
      return this.pickerMode === 'standard' ? this.standardCanvas : this.canvas;
    }

    setupFilterSections() {
      const sync = event => {
        const isMobile = event?.matches ?? this.mobileFilterQuery.matches;
        this.filterSections.forEach(section => {
          if (section.dataset.pcfFilterSection === 'brands') return;
          section.open = !isMobile;
        });
      };
      sync();
      this.mobileFilterQuery.addEventListener?.('change', sync);
    }

    selectedFilterLabel(inputs, fallback = 'Any') {
      const selected = inputs.find(input => input.checked);
      return selected?.closest('label')?.querySelector('span')?.textContent?.trim() || fallback;
    }

    updateFilterSummaries() {
      const mode = this.filterValues.get('mode');
      const application = this.filterValues.get('application');
      const chemistry = this.filterValues.get('chemistry');
      if (mode) mode.textContent = this.selectedFilterLabel(this.modeInputs);
      if (application) application.textContent = this.selectedFilterLabel(this.applicationInputs);
      if (chemistry) chemistry.textContent = this.selectedFilterLabel(this.chemistryInputs);
    }

    selectedMode() {
      return this.modeInputs.find(input => input.checked)?.value || 'all';
    }

    selectedChemistry() {
      return this.chemistryInputs.find(input => input.checked)?.value || 'all';
    }

    setChemistry(value) {
      const selected = this.chemistryInputs.find(input => input.value === value) || this.chemistryInputs.find(input => input.value === 'all');
      if (selected) selected.checked = true;
    }

    selectedApplication() {
      return this.applicationInputs.find(input => input.checked)?.value || 'all';
    }

    setApplication(value) {
      const applications = this.normalizeApplications(value);
      const selected = applications.length === 1 ? applications[0] : 'all';
      const input = this.applicationInputs.find(option => option.value === selected) || this.applicationInputs.find(option => option.value === 'all');
      if (input) input.checked = true;
    }

    updateBrandSummary() {
      if (!this.brandSummary) return;
      const selected = this.brandInputs.filter(input => input.checked).length;
      this.brandSummary.textContent = selected === this.brandInputs.length ? 'All selected' : (selected === 0 ? 'None selected' : `${selected} of ${this.brandInputs.length} selected`);
      if (this.selectAllBrandsButton) this.selectAllBrandsButton.disabled = selected === this.brandInputs.length;
      if (this.deselectAllBrandsButton) this.deselectAllBrandsButton.disabled = selected === 0;
    }

    setAllBrands(checked) {
      this.brandInputs.forEach(input => {
        input.checked = checked;
      });
      this.updateBrandSummary();
      this.scheduleSearch();
    }

    drawActivePicker() {
      if (this.pickerMode === 'standard') {
        this.drawStandardPicker();
        this.drawHueStrip();
      } else {
        this.drawWheel();
      }
      this.updatePickerAria();
    }

    drawWheel() {
      const { width, height } = this.canvas;
      const image = this.ctx.createImageData(width, height);
      const radius = width / 2 - 2;
      for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
          const dx = x - width / 2;
          const dy = y - height / 2;
          const distance = Math.sqrt(dx * dx + dy * dy);
          const offset = (y * width + x) * 4;
          if (distance <= radius) {
            const hue = (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
            const [r, g, b] = this.hsvToRgb(hue, distance / radius, this.hsv.v);
            image.data.set([r, g, b, 255], offset);
          }
        }
      }
      this.ctx.putImageData(image, 0, 0);
      const angle = this.hsv.h * Math.PI / 180;
      const markerRadius = this.hsv.s * radius;
      const x = width / 2 + Math.cos(angle) * markerRadius;
      const y = height / 2 + Math.sin(angle) * markerRadius;
      this.ctx.beginPath();
      this.ctx.arc(x, y, 7, 0, Math.PI * 2);
      this.ctx.strokeStyle = this.hsv.v > .55 ? '#111111' : '#ffffff';
      this.ctx.lineWidth = 3;
      this.ctx.stroke();
    }

    drawStandardPicker() {
      const { width, height } = this.standardCanvas;
      const [r, g, b] = this.hsvToRgb(this.hsv.h, 1, 1);
      this.standardCtx.fillStyle = `rgb(${r} ${g} ${b})`;
      this.standardCtx.fillRect(0, 0, width, height);
      const saturation = this.standardCtx.createLinearGradient(0, 0, width, 0);
      saturation.addColorStop(0, '#ffffff');
      saturation.addColorStop(1, 'rgba(255,255,255,0)');
      this.standardCtx.fillStyle = saturation;
      this.standardCtx.fillRect(0, 0, width, height);
      const brightness = this.standardCtx.createLinearGradient(0, 0, 0, height);
      brightness.addColorStop(0, 'rgba(0,0,0,0)');
      brightness.addColorStop(1, '#000000');
      this.standardCtx.fillStyle = brightness;
      this.standardCtx.fillRect(0, 0, width, height);
      const x = Math.max(7, Math.min(width - 7, this.hsv.s * (width - 1)));
      const y = Math.max(7, Math.min(height - 7, (1 - this.hsv.v) * (height - 1)));
      this.standardCtx.beginPath();
      this.standardCtx.arc(x, y, 7, 0, Math.PI * 2);
      this.standardCtx.strokeStyle = '#111111';
      this.standardCtx.lineWidth = 4;
      this.standardCtx.stroke();
      this.standardCtx.beginPath();
      this.standardCtx.arc(x, y, 7, 0, Math.PI * 2);
      this.standardCtx.strokeStyle = '#ffffff';
      this.standardCtx.lineWidth = 2;
      this.standardCtx.stroke();
    }

    drawHueStrip() {
      const { width, height } = this.hueCanvas;
      const gradient = this.hueCtx.createLinearGradient(0, 0, 0, height);
      ['#ff0000', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#ff00ff', '#ff0000'].forEach((color, index) => gradient.addColorStop(index / 6, color));
      this.hueCtx.fillStyle = gradient;
      this.hueCtx.fillRect(0, 0, width, height);
      const y = Math.max(4, Math.min(height - 4, this.hsv.h / 360 * (height - 1)));
      this.hueCtx.strokeStyle = '#111111';
      this.hueCtx.lineWidth = 4;
      this.hueCtx.strokeRect(1, y - 4, width - 2, 8);
      this.hueCtx.strokeStyle = '#ffffff';
      this.hueCtx.lineWidth = 2;
      this.hueCtx.strokeRect(1, y - 4, width - 2, 8);
    }

    updatePickerAria() {
      const hue = Math.round(this.hsv.h) % 360;
      const saturation = Math.round(this.hsv.s * 100);
      const brightness = Math.round(this.hsv.v * 100);
      this.canvas.setAttribute('aria-valuenow', String(hue));
      this.canvas.setAttribute('aria-valuetext', `${hue} degree hue, ${saturation} percent saturation, ${brightness} percent brightness`);
      this.standardCanvas.setAttribute('aria-valuenow', String(saturation));
      this.standardCanvas.setAttribute('aria-valuetext', `${saturation} percent saturation, ${brightness} percent brightness`);
      this.hueCanvas.setAttribute('aria-valuenow', String(hue));
      this.hueCanvas.setAttribute('aria-valuetext', `${hue} degree hue`);
    }

    pickFromPointer(event) {
      const rect = this.canvas.getBoundingClientRect();
      const x = (event.clientX - rect.left) * this.canvas.width / rect.width - this.canvas.width / 2;
      const y = (event.clientY - rect.top) * this.canvas.height / rect.height - this.canvas.height / 2;
      const radius = this.canvas.width / 2 - 2;
      this.hsv.h = (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
      this.hsv.s = Math.min(1, Math.sqrt(x * x + y * y) / radius);
      this.applyColor(this.hsvToHex(this.hsv));
    }

    pickFromStandardPointer(event) {
      const rect = this.standardCanvas.getBoundingClientRect();
      const x = Math.max(0, Math.min(this.standardCanvas.width - 1, (event.clientX - rect.left) * this.standardCanvas.width / rect.width));
      const y = Math.max(0, Math.min(this.standardCanvas.height - 1, (event.clientY - rect.top) * this.standardCanvas.height / rect.height));
      this.hsv.s = x / (this.standardCanvas.width - 1);
      this.hsv.v = 1 - y / (this.standardCanvas.height - 1);
      this.brightness.value = Math.round(this.hsv.v * 100);
      this.applyColor(this.hsvToHex(this.hsv));
    }

    pickHueFromPointer(event) {
      const rect = this.hueCanvas.getBoundingClientRect();
      const y = Math.max(0, Math.min(this.hueCanvas.height - 1, (event.clientY - rect.top) * this.hueCanvas.height / rect.height));
      this.hsv.h = Math.min(359.999, y / (this.hueCanvas.height - 1) * 360);
      this.applyColor(this.hsvToHex(this.hsv));
    }

    applyColor(hex, search = true) {
      const value = hex.toUpperCase();
      this.hexInput.value = value;
      this.nativeInput.value = value;
      this.preview.style.background = value;
      this.preview.setAttribute('aria-label', `Selected color ${value}`);
      this.drawActivePicker();
      if (search) this.scheduleSearch();
    }

    scheduleSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.search(), 90);
    }

    async search() {
      const token = Symbol('search');
      this.searchToken = token;
      const index = await this.indexPromise;
      if (this.searchToken !== token) return;
      if (!index.length) {
        this.results.replaceChildren();
        this.clearClosestMatch('No closest match is available.');
        this.status.textContent = this.indexError ? 'Paint index could not be loaded.' : 'No paints are currently indexed.';
        return;
      }
      const selectedMode = this.selectedMode();
      const targetLab = selectedMode === 'color_shift' ? null : this.hexToLab(this.hexInput.value);
      const targetShiftLabs = selectedMode === 'color_shift'
        ? [this.hexToLab(this.shiftStartInput.value), this.hexToLab(this.shiftEndInput.value)]
        : null;
      const brands = new Set(this.brandInputs.filter(input => input.checked).map(input => input.value));
      const sourceHandle = this.lookupSourceHandle || this.dataset.sourceHandle;
      const preferredHandle = selectedMode !== 'color_shift' && !sourceHandle && this.normalizeHex(this.hexInput.value) === this.normalizeHex(this.dataset.sourceHex) ? this.dataset.defaultMatchHandle : '';
      const selectedChemistry = this.selectedChemistry();
      const selectedApplication = this.selectedApplication();
      const candidates = this.index
        .filter(item => selectedMode === 'color_shift' || item.handle !== sourceHandle)
        .filter(item => selectedMode === 'all' || this.modeFor(item) === selectedMode)
        .filter(item => selectedMode !== 'color_shift' || (Array.isArray(item.shiftLabs) && item.shiftLabs.length >= 2))
        .filter(item => selectedChemistry === 'all' || this.chemistryFor(item) === selectedChemistry)
        .filter(item => selectedApplication === 'all' || this.applicationsFor(item).includes(selectedApplication))
        .filter(item => brands.has(item.brand))
        .map(item => ({ ...item, distance: selectedMode === 'color_shift' ? this.shiftPaletteDistance(targetShiftLabs, item) : this.deltaE2000(targetLab, item.lab) }))
        .filter(item => Number.isFinite(item.distance))
        .sort((a, b) => this.compareCandidateMatches(a, b, preferredHandle));
      this.status.textContent = candidates.length ? 'Checking current prices and availability…' : 'No eligible paints match these filters.';
      this.results.replaceChildren();
      this.clearClosestMatch(candidates.length ? 'Checking for the closest match.' : 'No eligible closest match for these filters.');
      const chosen = [];
      const resultLimit = selectedMode === 'color_shift' ? 40 : 12;
      const batchSize = selectedMode === 'color_shift' ? 40 : 24;
      const concurrency = selectedMode === 'color_shift' ? 8 : 4;
      for (let offset = 0; offset < candidates.length && chosen.length < resultLimit; offset += batchSize) {
        const group = candidates.slice(offset, offset + batchSize);
        const live = await this.mapLimit(group, concurrency, item => this.fetchProduct(item));
        if (this.searchToken !== token) return;
        for (const entry of live) {
          if (!entry) continue;
          if (selectedMode !== 'color_shift' && this.stock.checked && !entry.product.available) continue;
          chosen.push(entry);
          if (chosen.length === resultLimit) break;
        }
      }
      if (this.searchToken !== token) return;
      this.render(chosen);
    }

    async fetchProduct(item) {
      const product = await this.fetchStoreProduct(item.handle);
      return product ? { item, product } : null;
    }

    async fetchStoreProduct(handle) {
      const key = String(handle || '').trim();
      if (!key) return null;
      if (!window.__lionheartProductPromises.has(key)) {
        const root = window.Shopify?.routes?.root || '/';
        const request = fetch(`${root}products/${encodeURIComponent(key)}.js`, { headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : null)
          .catch(() => null);
        window.__lionheartProductPromises.set(key, request);
      }
      return window.__lionheartProductPromises.get(key);
    }

    async mapLimit(items, limit, callback) {
      const output = new Array(items.length);
      let cursor = 0;
      const worker = async () => {
        while (cursor < items.length) {
          const index = cursor++;
          output[index] = await callback(items[index]);
        }
      };
      await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
      return output;
    }

    render(entries) {
      const shiftMode = this.selectedMode() === 'color_shift';
      this.results.classList.toggle('is-shift-grid', shiftMode);
      if (!entries.length) {
        this.clearClosestMatch('No eligible closest match for these filters.');
        this.status.textContent = shiftMode ? 'No color-shift paints were found for these filters.' : (this.stock.checked ? 'No in-stock paints were found for these filters.' : 'No paints were found for these filters.');
        return;
      }
      const rankedEntries = entries.map((entry, index) => ({ ...entry, rank: index + 1 }));
      this.setClosestMatch(rankedEntries[0]);
      this.status.textContent = shiftMode
        ? `${entries.length} color-shift ${entries.length === 1 ? 'paint' : 'paints'} — closest transitions first. Hover or focus any tile to preview it.`
        : `${entries.length} ranked ${entries.length === 1 ? 'match' : 'matches'} — closest first. Labels summarize digital color closeness.`;
      const fragment = document.createDocumentFragment();
      rankedEntries.forEach(entry => {
        const { item, product, rank } = entry;
        const score = this.matchPercent(item.distance);
        const distance = Number(item.distance).toFixed(2);
        const quality = shiftMode ? this.shiftMatchLabel(item.distance) : this.matchLabel(score);
        const basecoat = this.basecoatLabel(item.effectBasecoat);
        const variant = product.variants?.find(candidate => candidate.available) || product.variants?.[0];
        const available = Boolean(product.available && variant?.available);
        const card = document.createElement('article');
        card.className = `paint-finder__card${shiftMode ? ' paint-finder__card--shift' : ''}${available ? '' : ' paint-finder__card--sold-out'}${rank === 1 ? ' is-compared' : ''}`;
        card.dataset.rank = String(rank);
        const productUrl = this.escape(product.url || `${window.Shopify?.routes?.root || '/'}products/${item.handle}`);
        const image = product.featured_image || product.images?.[0] || '';
        const details = [item.brand, item.range, Array.isArray(item.skus) ? item.skus.find(Boolean) : item.sku].filter(Boolean).map(value => this.escape(value)).join(' · ');
        const tags = [this.chemistryLabel(this.chemistryFor(item)), ...this.applicationsFor(item).map(value => this.applicationLabel(value))].map(value => `<span class="paint-finder__card-tag">${this.escape(value)}</span>`).join('');
        const title = this.escape(product.title);
        const rackLocation = this.rackLocationFor(item);
        const rackBadge = rackLocation ? `<span class="paint-finder__rack-location" title="${this.escape(rackLocation.full)}" aria-label="In-store location: ${this.escape(rackLocation.full)}">📍 ${this.escape(rackLocation.short)}</span>` : '';
        const addLabel = this.escape(this.dataset.addLabel || 'Add to cart');
        const inStockLabel = this.escape(this.dataset.inStockLabel || 'In stock');
        const soldOutLabel = this.escape(this.dataset.soldOutLabel || 'Sold out');
        const viewLabel = this.escape(this.dataset.viewLabel || 'View paint');
        const shiftHexes = (Array.isArray(item.shiftHexes) ? item.shiftHexes : []).map(value => this.normalizeHex(value)).filter(Boolean);
        const paletteLabel = shiftHexes.join(' to ');
        const requirement = `Must be painted over ${basecoat.toLowerCase()} to achieve this effect.`;
        const metaSwatch = shiftMode
          ? `<span class="paint-finder__shift-palette paint-finder__shift-palette--tile" role="img" aria-label="Representative shift colors ${this.escape(paletteLabel)}">${shiftHexes.map(value => `<span class="paint-finder__swatch" style="background:${value}" aria-hidden="true"></span>`).join('')}</span>`
          : `<span class="paint-finder__swatch" style="background:${item.hex}"></span>`;
        const matchSummary = shiftMode
          ? `<span class="paint-finder__card-match" aria-label="${this.escape(quality)}. Must be painted over ${this.escape(basecoat.toLowerCase())} to achieve this effect. Average representative digital endpoint distance ${distance}" title="${this.escape(quality)}. Average representative digital endpoint distance ${distance}."><strong>${this.escape(quality)}</strong><small>Over ${this.escape(basecoat.toLowerCase())}</small></span>`
          : `<span class="paint-finder__card-match" aria-label="${quality}, ${score} percent digital color match; CIEDE2000 distance ${distance}" title="${quality}. ${score}% display score from CIEDE2000 distance ${distance}"><strong>${quality}</strong><small>${score}% color match</small></span>`;
        const compactDetails = [item.brand, Array.isArray(item.skus) ? item.skus.find(Boolean) : item.sku].filter(Boolean).map(value => this.escape(value)).join(' · ');
        const cartAction = available
          ? `<form class="paint-finder__cart-form" method="post" action="${this.escape((window.Shopify?.routes?.root || '/') + 'cart/add')}" data-pcf-cart-form><input type="hidden" name="id" value="${this.escape(String(variant.id))}"><input type="hidden" name="quantity" value="1"><button class="Sd_addProduct add_to_cart button xsmall-btn paint-finder__add-to-cart" type="submit" data-pcf-add data-default-label="${addLabel}" aria-label="${addLabel}: ${title}"><span data-pcf-add-label>${addLabel}</span><svg class="svg-loader" style="margin: auto; display: none; shape-rendering: auto;" width="24" height="24" viewBox="0 0 100 100" aria-hidden="true" focusable="false"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="7" r="35" stroke-dasharray="165 57"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50"></animateTransform></circle></svg></button><span class="visually-hidden" data-pcf-cart-status aria-live="polite"></span></form>`
          : `<button class="button xsmall-btn paint-finder__add-to-cart" type="button" disabled>${soldOutLabel}</button>`;
        card.innerHTML = shiftMode
          ? `<a class="paint-finder__card-image" href="${productUrl}" aria-label="${title}">${image ? `<img src="${this.escape(image)}" alt="" loading="lazy" width="144" height="144">` : ''}</a><div class="paint-finder__card-body"><span class="paint-finder__shift-quality">${this.escape(quality)}</span><a class="paint-finder__card-title" href="${productUrl}">${title}</a><span class="paint-finder__card-meta">${metaSwatch}${compactDetails}</span><strong class="paint-finder__card-requirement">${this.escape(requirement)}</strong></div><div class="paint-finder__card-purchase"><span class="paint-finder__shift-price-state"><span class="paint-finder__card-price">${this.money(product.price)}</span><span class="paint-finder__card-state">${available ? inStockLabel : soldOutLabel}</span></span><div class="paint-finder__card-actions"><a class="button xsmall-btn paint-finder__details-link" href="${productUrl}">${viewLabel}</a>${cartAction}</div></div>`
          : `<div class="paint-finder__card-leading"><span class="paint-finder__card-rank" aria-label="Rank ${rank}">#${rank}</span>${matchSummary}</div><a class="paint-finder__card-image" href="${productUrl}" aria-label="${title}">${image ? `<img src="${this.escape(image)}" alt="" loading="lazy" width="144" height="144">` : ''}</a><div class="paint-finder__card-body"><a class="paint-finder__card-title" href="${productUrl}">${title}</a><span class="paint-finder__card-meta">${metaSwatch}${details}</span><span class="paint-finder__card-tags">${tags}</span><span class="paint-finder__card-footer"><span class="paint-finder__card-state">${available ? inStockLabel : soldOutLabel}</span>${rackBadge}</span></div><div class="paint-finder__card-purchase"><span class="paint-finder__card-price">${this.money(product.price)}</span><div class="paint-finder__card-actions"><a class="button xsmall-btn paint-finder__details-link" href="${productUrl}">${viewLabel}</a>${cartAction}</div></div>`;
        card.addEventListener('pointerenter', () => this.previewMatch(entry));
        card.addEventListener('pointerleave', () => this.restoreClosestMatch());
        card.addEventListener('focusin', () => this.previewMatch(entry));
        card.addEventListener('focusout', event => {
          if (!card.contains(event.relatedTarget)) this.restoreClosestMatch();
        });
        fragment.append(card);
      });
      this.results.replaceChildren(fragment);
    }

    async addPaintToCart(button) {
      if (button.disabled) return;
      const form = button.closest('form');
      if (!form) return;
      const label = button.querySelector('[data-pcf-add-label]');
      const status = form.querySelector('[data-pcf-cart-status]');
      const defaultLabel = button.dataset.defaultLabel || this.dataset.addLabel || 'Add to cart';
      const addingLabel = this.dataset.addingLabel || 'Adding…';
      const addedLabel = this.dataset.addedLabel || 'Added!';
      const retryLabel = this.dataset.tryAgainLabel || 'Try again';
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      if (status) status.textContent = addingLabel;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || this.dataset.cartErrorLabel || 'Could not add this paint.');
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.removeAttribute('aria-busy');
        if (label) label.textContent = addedLabel;
        if (status) status.textContent = addedLabel;
        if (this.dialog?.open) this.dialog.close();
        if (cart && typeof window.buildCart === 'function') {
          requestAnimationFrame(() => window.buildCart(cart, true, button));
        } else if (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(element => {
            element.textContent = cart.item_count < 100 ? String(cart.item_count) : '';
            element.hidden = cart.item_count === 0;
          });
        }
        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
          if (label) label.textContent = defaultLabel;
        }, 2400);
      } catch (error) {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label) label.textContent = retryLabel;
        if (status) status.textContent = error.message || this.dataset.cartErrorLabel || 'Could not add this paint. Please try again.';
        window.setTimeout(() => {
          if (label) label.textContent = defaultLabel;
        }, 2600);
      }
    }

    setClosestMatch(entry) {
      this.closestEntry = entry;
      this.setComparison(entry, false);
      if (this.selectedMode() === 'color_shift') this.previewShiftPaint(entry.item);
    }

    previewMatch(entry) {
      this.setComparison(entry, entry.rank !== 1);
      if (this.selectedMode() === 'color_shift') this.previewShiftPaint(entry.item);
      this.updateComparedCard(entry.rank);
    }

    restoreClosestMatch() {
      if (!this.closestEntry) return;
      this.setComparison(this.closestEntry, false);
      if (this.selectedMode() === 'color_shift') this.previewShiftPaint(this.closestEntry.item);
      this.updateComparedCard(1);
    }

    updateComparedCard(rank) {
      this.results.querySelectorAll('.paint-finder__card').forEach(card => card.classList.toggle('is-compared', Number(card.dataset.rank) === rank));
    }

    setComparison({ item, product, rank = 1 }, previewing = false) {
      const value = this.normalizeHex(item.hex) || item.hex;
      const name = product.title || this.paintName(item);
      const prefix = previewing ? `Rank ${rank} preview` : 'Closest match';
      this.closestPreview.classList.remove('is-empty');
      if (this.selectedMode() === 'color_shift') {
        const colors = (Array.isArray(item.shiftHexes) ? item.shiftHexes : []).map(color => this.normalizeHex(color)).filter(Boolean);
        const quality = this.shiftMatchLabel(item.distance);
        const basecoat = this.basecoatLabel(item.effectBasecoat);
        const palette = colors.join(' to ');
        const requirement = `Must be painted over ${basecoat.toLowerCase()} to achieve this effect.`;
        const label = `${prefix}: ${name}, representative shift ${palette}, ${quality}. ${requirement}`;
        this.closestPreview.style.background = `linear-gradient(90deg,${colors.join(',')})`;
        this.closestPreview.setAttribute('aria-label', label);
        this.closestPreview.title = label;
        if (this.closestCaption) this.closestCaption.textContent = previewing ? `Comparing #${rank}` : 'Closest paint';
        this.closestName.textContent = `${previewing ? `#${rank}` : 'Closest paint'}: ${name} (${palette}) · ${quality} · ${requirement}`;
        return;
      }
      const score = this.matchPercent(item.distance);
      const quality = this.matchLabel(score);
      const label = `${prefix}: ${name}, ${value}, ${quality}, ${score} percent digital color match`;
      this.closestPreview.style.background = value;
      this.closestPreview.setAttribute('aria-label', label);
      this.closestPreview.title = label;
      if (this.closestCaption) this.closestCaption.textContent = previewing ? `Comparing #${rank}` : 'Closest paint';
      this.closestName.textContent = `${previewing ? `#${rank}` : 'Closest paint'}: ${name} (${value}) · ${quality} (${score}%)`;
    }

    clearClosestMatch(label) {
      this.closestEntry = null;
      this.closestPreview.classList.add('is-empty');
      this.closestPreview.style.removeProperty('background');
      this.closestPreview.setAttribute('aria-label', label);
      this.closestPreview.removeAttribute('title');
      if (this.closestCaption) this.closestCaption.textContent = 'Closest paint';
      this.closestName.textContent = label;
      if (this.selectedMode() === 'color_shift') this.updateShiftPreview();
      this.results.querySelectorAll('.paint-finder__card').forEach(card => card.classList.remove('is-compared'));
    }

    useLookupPaint() {
      const query = this.normalizeLookup(this.lookupInput?.value);
      if (!query) {
        this.lookupStatus.textContent = 'Enter a paint name or number.';
        this.lookupInput?.focus();
        return;
      }
      const selectedBrand = this.lookupBrand?.value || 'all';
      const matches = this.index
        .filter(item => selectedBrand === 'all' || item.brand === selectedBrand)
        .map(item => {
          const exactCodes = [...(Array.isArray(item.skus) ? item.skus : [item.sku]), ...(Array.isArray(item.barcodes) ? item.barcodes : [item.barcode])].filter(Boolean).map(value => this.normalizeLookup(value));
          const name = this.normalizeLookup(this.paintName(item));
          const title = this.normalizeLookup(item.title);
          const handle = this.normalizeLookup(String(item.handle || '').replace(/-/g, ' '));
          const values = [name, title, handle, ...exactCodes].filter(Boolean);
          let score = 99;
          if (exactCodes.includes(query)) score = 0;
          else if (name === query) score = 1;
          else if (title === query || handle === query) score = 2;
          else if (values.some(value => value.startsWith(query))) score = 3;
          else if (values.some(value => value.includes(query))) score = 4;
          return { item, score };
        })
        .filter(entry => entry.score < 99)
        .sort((a, b) => a.score - b.score || this.paintName(a.item).localeCompare(this.paintName(b.item)) || String(a.item.brand).localeCompare(String(b.item.brand)));
      if (!matches.length) {
        this.lookupStatus.textContent = 'No indexed paint matched that name or number.';
        return;
      }
      const best = matches[0].item;
      const sameRank = matches.filter(entry => entry.score === matches[0].score);
      if (selectedBrand === 'all' && sameRank.length > 1 && matches[0].score <= 2) {
        const brands = [...new Set(sameRank.map(entry => entry.item.brand))];
        if (brands.length > 1) {
          this.lookupStatus.textContent = `More than one paint matched. Choose a brand: ${brands.join(', ')}.`;
          return;
        }
      }
      this.lookupInput.value = this.paintName(best);
      this.lookupSourceHandle = best.handle;
      const mode = this.modeFor(best);
      const modeInput = this.modeInputs.find(input => input.value === mode);
      if (modeInput) modeInput.checked = true;
      this.updateModeInterface();
      this.setChemistry(this.chemistryFor(best));
      this.setApplication(this.applicationsFor(best));
      this.updateFilterSummaries();
      this.hsv = this.hexToHsv(best.hex);
      this.brightness.value = Math.round(this.hsv.v * 100);
      this.applyColor(best.hex, false);
      if (mode === 'color_shift') this.seedShiftGeneratorFromSource(best);
      const code = Array.isArray(best.skus) ? best.skus.find(Boolean) : best.sku;
      this.lookupStatus.textContent = `Using ${this.paintName(best)}${code ? ` (${code})` : ''} by ${best.brand}.`;
      this.scheduleSearch();
    }

    rackLocationFor(item) {
      const code = String((Array.isArray(item.skus) ? item.skus.find(Boolean) : item.sku) || '').toUpperCase().trim();
      const ordinal = value => {
        const n = Number(value);
        const mod100 = n % 100;
        if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
        return `${n}${({ 1: 'st', 2: 'nd', 3: 'rd' })[n % 10] || 'th'}`;
      };
      const ak = code.match(/(?:AK)?(11\d{3})$/);
      if (ak) {
        const number = Number(ak[1]);
        if (number >= 11001 && number <= 11236) {
          const offset = number - 11001;
          const row = offset < 220 ? Math.floor(offset / 20) + 1 : 12;
          const slot = offset < 220 ? (offset % 20) + 1 : offset - 220 + 1;
          return { short: `AK 3G · Row ${row} · #${slot}`, full: `AK 3G rack, ${ordinal(row)} row, ${ordinal(slot)} from left` };
        }
      }
      const pro = code.match(/^MPA-(\d{3})$/);
      if (pro) {
        const n = Number(pro[1]);
        let row = 0, slot = 0;
        if (n >= 1 && n <= 48) { row = Math.floor((n - 1) / 12) + 1; slot = ((n - 1) % 12) + 1; }
        else if (n >= 49 && n <= 59) { row = 5; slot = n - 48; }
        else {
          const row6 = [60,62,63,61,65,66,67,68,69,70,71,72];
          const row7 = [73,74,75,200,201,202];
          if (row6.includes(n)) { row = 6; slot = row6.indexOf(n) + 1; }
          else if (row7.includes(n)) { row = 7; slot = row7.indexOf(n) + 1; }
        }
        if (row && slot) return { short: `Pro Acryl · Row ${row} · #${slot}`, full: `Pro Acryl rack, ${ordinal(row)} row, ${ordinal(slot)} from left` };
      }
      return null;
    }

    paintName(item) {
      return String(item.title || item.colorLabel || item.handle || '')
        .replace(/^(?:Base|Layer|Contrast|Shade|Dry|Technical):\s*/i, '')
        .replace(/\s*\(\d+\s*ml\)\s*$/i, '')
        .trim();
    }

    normalizeLookup(value) {
      return String(value || '').toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '');
    }

    modeFor(item) {
      const explicit = String(item.mode || '').toLowerCase();
      const description = [item.matchClass, item.paintType, item.finish, item.opacity].filter(Boolean).join(' ').toLowerCase();
      const identity = [description, item.range, item.title].filter(Boolean).join(' ').toLowerCase();
      if (/color[-_ ]?shift|turboshift|zenishift/.test(identity)) return 'color_shift';
      if (['matte', 'gloss', 'metallic', 'color_shift', 'transparent', 'fluorescent', 'wash', 'effect', 'contrast_speed'].includes(explicit)) return explicit;
      if (/metallic|pearl|pearlescent|color[-_ ]?shift/.test(description)) return 'metallic';
      if (/fluorescent|\bfluor\b/.test(description)) return 'fluorescent';
      if (/\bwash\b|\bink\b/.test(description)) return 'wash';
      if (/\beffect\b|\btechnical\b/.test(description)) return 'effect';
      if (/transparent|\bclear\b/.test(description)) return 'transparent';
      if (/contrast|speed[-_ ]?paint|xpress|instant[-_ ]?color/.test(description)) return 'contrast_speed';
      if (/gloss/.test(description)) return 'gloss';
      return 'matte';
    }

    chemistryFor(item) {
      const value = String(item.chemistry || item.paintChemistry || '').toLowerCase().replace(/[ -]+/g, '_');
      if (value.includes('alcohol')) return 'alcohol_based_acrylic';
      if (value.includes('lacquer')) return 'lacquer';
      if (value.includes('enamel')) return 'enamel';
      if (value.includes('solvent')) return 'solvent_based_acrylic';
      if (value.includes('oil')) return 'oil_based';
      if (value.includes('wax')) return 'wax_based';
      return 'water_based_acrylic';
    }

    applicationsFor(item) {
      const value = item.applications || item.applicationMethods || item.application || item.applicationMethod || '';
      const applications = this.normalizeApplications(value);
      return applications.length ? applications : ['brush_on'];
    }

    normalizeApplications(value) {
      const values = Array.isArray(value) ? value : String(value || '').split(/[,|;/]+/);
      return [...new Set(values.map(entry => {
        const normalized = String(entry || '').trim().toLowerCase().replace(/[ -]+/g, '_');
        if (/spray|aerosol/.test(normalized)) return 'spray';
        if (/marker/.test(normalized)) return 'marker';
        if (/air_?brush/.test(normalized)) return 'airbrush';
        if (/brush_?on|brush/.test(normalized)) return 'brush_on';
        return '';
      }).filter(Boolean))];
    }

    modeLabel(value) {
      return { all: 'Any', matte: 'Matte', gloss: 'Gloss', metallic: 'Metallic / Pearl', color_shift: 'Color shift', transparent: 'Transparent', fluorescent: 'Fluorescent', wash: 'Wash / Ink', effect: 'Effects', contrast_speed: 'Contrast / Speed Paint' }[value] || value;
    }

    updateModeInterface() {
      const shiftMode = this.selectedMode() === 'color_shift';
      if (this.samplingShiftHelp) this.samplingShiftHelp.hidden = !shiftMode;
      if (this.flatPicker) this.flatPicker.hidden = shiftMode;
      if (this.shiftGenerator) this.shiftGenerator.hidden = !shiftMode;
      if (this.stockCheck) this.stockCheck.hidden = shiftMode;
      if (this.resultsTitle) this.resultsTitle.textContent = shiftMode ? 'Browse color-shift paints' : 'Closest paint matches';
      if (shiftMode) this.updateShiftPreview();
    }

    updateShiftPreview() {
      if (!this.shiftSphere || !this.shiftStartInput || !this.shiftEndInput) return;
      const start = this.normalizeHex(this.shiftStartInput.value) || '#3F78A6';
      const end = this.normalizeHex(this.shiftEndInput.value) || '#C74D9A';
      const middle = this.mixHex(start, end, .5);
      const angle = Math.max(0, Math.min(100, Number(this.shiftAngleInput?.value || 50)));
      this.shiftSphere.classList.remove('is-result-preview');
      if (this.shiftPreviewLabel) this.shiftPreviewLabel.textContent = 'Your transition';
      if (this.shiftRequirement) this.shiftRequirement.textContent = 'Select or hover a paint to see its required basecoat.';
      this.shiftStartOutput.textContent = start;
      this.shiftEndOutput.textContent = end;
      this.shiftAngleOutput.textContent = `${Math.round(angle)}%`;
      this.shiftStage.dataset.basecoat = 'all';
      this.shiftSphere.style.setProperty('--pcf-shift-start', start);
      this.shiftSphere.style.setProperty('--pcf-shift-middle', middle);
      this.shiftSphere.style.setProperty('--pcf-shift-end', end);
      this.shiftSphere.style.setProperty('--pcf-shift-position', `${angle}%`);
      this.shiftSphere.style.setProperty('--pcf-angle-offset', `${(angle - 50) * .45}%`);
      const label = `Illustrative color-shift sphere from ${start} to ${end}, ${Math.round(angle)} percent viewing angle`;
      this.shiftSphere.setAttribute('aria-label', label);
      this.shiftSphere.title = label;
    }

    previewShiftPaint(item) {
      if (!this.shiftSphere || !this.shiftStage || !item) return;
      const colors = (Array.isArray(item.shiftHexes) ? item.shiftHexes : []).map(value => this.normalizeHex(value)).filter(Boolean);
      if (colors.length < 2) return;
      this.shiftSphere.classList.remove('is-result-preview');
      const start = colors[0];
      const end = colors[colors.length - 1];
      const middle = colors.length > 2 ? colors[Math.floor(colors.length / 2)] : this.mixHex(start, end, .5);
      const focus = this.dramaticShiftFocus(item, colors);
      const basecoat = item.effectBasecoat || 'all';
      const name = this.paintName(item);
      this.shiftStage.dataset.basecoat = basecoat;
      this.shiftSphere.style.setProperty('--pcf-shift-start', start);
      this.shiftSphere.style.setProperty('--pcf-shift-middle', middle);
      this.shiftSphere.style.setProperty('--pcf-shift-end', end);
      this.shiftSphere.style.setProperty('--pcf-shift-focus', `${focus}%`);
      this.shiftSphere.dataset.shiftFocus = String(focus);
      void this.shiftSphere.offsetWidth;
      this.shiftSphere.classList.add('is-result-preview');
      if (this.shiftPreviewLabel) this.shiftPreviewLabel.textContent = name;
      const requirement = `Must be painted over ${this.basecoatLabel(basecoat).toLowerCase()} to achieve this effect.`;
      if (this.shiftRequirement) this.shiftRequirement.textContent = requirement;
      const label = `Animated representative color-shift preview for ${name}, ${colors.join(' to ')}. ${requirement}`;
      this.shiftSphere.setAttribute('aria-label', label);
      this.shiftSphere.title = label;
    }

    renderProductShiftPreview() {
      if (!this.productShiftPreview || !this.productShiftSphere || !this.productShiftStage) return;
      const item = this.index.find(candidate => candidate.handle === this.dataset.sourceHandle);
      const colors = (Array.isArray(item?.shiftHexes) ? item.shiftHexes : []).map(value => this.normalizeHex(value)).filter(Boolean);
      if (!item || this.modeFor(item) !== 'color_shift' || colors.length < 2) {
        this.productShiftPreview.hidden = true;
        return;
      }
      const start = colors[0];
      const end = colors[colors.length - 1];
      const middle = colors.length > 2 ? colors[Math.floor(colors.length / 2)] : this.mixHex(start, end, .5);
      const focus = this.dramaticShiftFocus(item, colors);
      const basecoat = item.effectBasecoat || 'all';
      const requirement = `Must be painted over ${this.basecoatLabel(basecoat).toLowerCase()} to achieve this effect.`;
      this.productShiftSphere.classList.remove('is-ready');
      this.productShiftStage.dataset.basecoat = basecoat;
      this.productShiftSphere.style.setProperty('--pcf-shift-start', start);
      this.productShiftSphere.style.setProperty('--pcf-shift-middle', middle);
      this.productShiftSphere.style.setProperty('--pcf-shift-end', end);
      this.productShiftSphere.style.setProperty('--pcf-shift-focus', `${focus}%`);
      this.productShiftSphere.dataset.shiftFocus = String(focus);
      if (this.productShiftColors) this.productShiftColors.textContent = `${colors.length}-color representative transition from official swatch imagery.`;
      if (this.productShiftRequirement) this.productShiftRequirement.textContent = requirement;
      const label = `Animated representative color-shift sphere for ${this.paintName(item)}, ${colors.join(' to ')}. ${requirement}`;
      this.productShiftSphere.setAttribute('aria-label', label);
      this.productShiftSphere.title = label;
      this.productShiftPreview.hidden = false;
      void this.productShiftSphere.offsetWidth;
      this.productShiftSphere.classList.add('is-ready');
    }

    seedShiftGeneratorFromSource(sourceItem = null) {
      if (!this.shiftStartInput || !this.shiftEndInput) return;
      const sourceHandle = this.lookupSourceHandle || this.dataset.sourceHandle;
      const item = sourceItem || (sourceHandle ? this.index.find(candidate => candidate.handle === sourceHandle) : null);
      if (!item || this.modeFor(item) !== 'color_shift') return;
      const colors = (Array.isArray(item.shiftHexes) ? item.shiftHexes : []).map(value => this.normalizeHex(value)).filter(Boolean);
      if (colors.length < 2) return;
      this.shiftStartInput.value = colors[0];
      this.shiftEndInput.value = colors[colors.length - 1];
      this.updateShiftPreview();
    }

    mixHex(first, second, amount = .5) {
      const start = (this.normalizeHex(first) || '#000000').slice(1).match(/.{2}/g).map(value => parseInt(value, 16));
      const end = (this.normalizeHex(second) || '#000000').slice(1).match(/.{2}/g).map(value => parseInt(value, 16));
      const ratio = Math.max(0, Math.min(1, Number(amount)));
      return `#${start.map((value, index) => Math.round(value + (end[index] - value) * ratio).toString(16).padStart(2, '0')).join('').toUpperCase()}`;
    }

    dramaticShiftFocus(item, colors) {
      if (!Array.isArray(colors) || colors.length < 2) return 50;
      const storedLabs = Array.isArray(item?.shiftLabs) ? item.shiftLabs : [];
      const labs = colors.map((color, index) => {
        const stored = storedLabs[index];
        return Array.isArray(stored) && stored.length === 3 && stored.every(Number.isFinite) ? stored : this.hexToLab(color);
      });
      let strongestPair = 0;
      let strongestDistance = -1;
      for (let index = 0; index < labs.length - 1; index += 1) {
        const distance = this.deltaE2000(labs[index], labs[index + 1]);
        if (distance > strongestDistance) {
          strongestDistance = distance;
          strongestPair = index;
        }
      }
      const pairMidpoint = ((strongestPair + .5) / (labs.length - 1)) * 100;
      return Math.round(Math.max(12, Math.min(88, pairMidpoint)));
    }

    shiftPaletteDistance(targetLabs, item) {
      if (!Array.isArray(targetLabs) || targetLabs.length < 2) return Infinity;
      const palette = (Array.isArray(item.shiftLabs) ? item.shiftLabs : []).filter(lab => Array.isArray(lab) && lab.length === 3 && lab.every(Number.isFinite));
      if (palette.length < 2) return Infinity;
      let best = Infinity;
      for (let first = 0; first < palette.length; first += 1) {
        for (let second = 0; second < palette.length; second += 1) {
          if (first === second) continue;
          const distance = (this.deltaE2000(targetLabs[0], palette[first]) + this.deltaE2000(targetLabs[1], palette[second])) / 2;
          if (distance < best) best = distance;
        }
      }
      return best;
    }

    shiftMatchLabel(distance) {
      const value = Number(distance);
      if (value <= .01) return 'Exact digital transition';
      if (value <= 7) return 'Very close transition';
      if (value <= 14) return 'Close transition';
      if (value <= 24) return 'Related transition';
      return 'Alternate transition';
    }

    basecoatLabel(value) {
      return { all: 'Any', black: 'Black', white: 'White', zenithal: 'Zenithal' }[value] || 'Specified';
    }

    chemistryLabel(value) {
      return {
        water_based_acrylic: 'Water-based acrylic',
        alcohol_based_acrylic: 'Alcohol-based acrylic',
        lacquer: 'Lacquer',
        enamel: 'Enamel',
        solvent_based_acrylic: 'Solvent-based acrylic',
        oil_based: 'Oil-based',
        wax_based: 'Wax-based'
      }[value] || value;
    }

    applicationLabel(value) {
      return { brush_on: 'Brush-on', airbrush: 'Airbrush', marker: 'Marker', spray: 'Spray' }[value] || value;
    }

    matchPercent(distance) {
      const value = Number(distance);
      if (!Number.isFinite(value) || value < 0) return 0;
      return Math.max(0, Math.min(100, Math.round(100 / (1 + (value / 12) ** 1.5))));
    }

    compareCandidateMatches(a, b, preferredHandle = '') {
      const distanceDifference = a.distance - b.distance;
      if (distanceDifference) return distanceDifference;
      if (preferredHandle) {
        if (a.handle === preferredHandle && b.handle !== preferredHandle) return -1;
        if (b.handle === preferredHandle && a.handle !== preferredHandle) return 1;
      }
      return a.handle.localeCompare(b.handle);
    }

    matchLabel(score) {
      if (score === 100) return 'Perfect match';
      if (score >= 90) return 'Excellent match';
      if (score >= 80) return 'Great match';
      if (score >= 70) return 'Good match';
      if (score >= 55) return 'Close match';
      return 'Similar shade';
    }

    money(cents) {
      const currency = window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100);
    }

    normalizeHex(value) {
      const match = String(value).trim().match(/^#?([0-9a-f]{6})$/i);
      return match ? `#${match[1].toUpperCase()}` : null;
    }

    escape(value) {
      return String(value ?? '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    }

    hexToHsv(hex) {
      const [r, g, b] = hex.match(/[0-9a-f]{2}/gi).map(value => parseInt(value, 16) / 255);
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const delta = max - min;
      let h = 0;
      if (delta) {
        if (max === r) h = 60 * (((g - b) / delta) % 6);
        else if (max === g) h = 60 * ((b - r) / delta + 2);
        else h = 60 * ((r - g) / delta + 4);
      }
      return { h: (h + 360) % 360, s: max ? delta / max : 0, v: max };
    }

    hsvToRgb(h, s, v) {
      const c = v * s;
      const x = c * (1 - Math.abs((h / 60) % 2 - 1));
      const m = v - c;
      const sectors = [[c,x,0],[x,c,0],[0,c,x],[0,x,c],[x,0,c],[c,0,x]];
      return sectors[Math.floor(h / 60) % 6].map(value => Math.round((value + m) * 255));
    }

    hsvToHex({ h, s, v }) {
      return `#${this.hsvToRgb(h, s, v).map(value => value.toString(16).padStart(2, '0')).join('')}`;
    }

    hexToLab(hex) {
      const values = hex.match(/[0-9a-f]{2}/gi).map(value => parseInt(value, 16) / 255).map(value => value <= .04045 ? value / 12.92 : ((value + .055) / 1.055) ** 2.4);
      const [r, g, b] = values;
      const x = (r * .4124564 + g * .3575761 + b * .1804375) / .95047;
      const y = r * .2126729 + g * .7151522 + b * .072175;
      const z = (r * .0193339 + g * .119192 + b * .9503041) / 1.08883;
      const f = value => value > .008856 ? Math.cbrt(value) : 7.787 * value + 16 / 116;
      return [116 * f(y) - 16, 500 * (f(x) - f(y)), 200 * (f(y) - f(z))];
    }

    deltaE2000(lab1, lab2) {
      const [L1, a1, b1] = lab1;
      const [L2, a2, b2] = lab2;
      const rad = Math.PI / 180;
      const deg = 180 / Math.PI;
      const C1 = Math.hypot(a1, b1);
      const C2 = Math.hypot(a2, b2);
      const Cbar = (C1 + C2) / 2;
      const G = .5 * (1 - Math.sqrt(Cbar ** 7 / (Cbar ** 7 + 25 ** 7)));
      const ap1 = (1 + G) * a1;
      const ap2 = (1 + G) * a2;
      const Cp1 = Math.hypot(ap1, b1);
      const Cp2 = Math.hypot(ap2, b2);
      const hp = (a, b) => {
        if (a === 0 && b === 0) return 0;
        const value = Math.atan2(b, a) * deg;
        return value >= 0 ? value : value + 360;
      };
      const hp1 = hp(ap1, b1);
      const hp2 = hp(ap2, b2);
      const dL = L2 - L1;
      const dC = Cp2 - Cp1;
      let dh = hp2 - hp1;
      if (Cp1 * Cp2 === 0) dh = 0;
      else if (dh > 180) dh -= 360;
      else if (dh < -180) dh += 360;
      const dH = 2 * Math.sqrt(Cp1 * Cp2) * Math.sin(dh * rad / 2);
      const Lbar = (L1 + L2) / 2;
      const Cpbar = (Cp1 + Cp2) / 2;
      let hpbar = hp1 + hp2;
      if (Cp1 * Cp2 === 0) hpbar = hp1 + hp2;
      else if (Math.abs(hp1 - hp2) <= 180) hpbar = (hp1 + hp2) / 2;
      else if (hp1 + hp2 < 360) hpbar = (hp1 + hp2 + 360) / 2;
      else hpbar = (hp1 + hp2 - 360) / 2;
      const T = 1 - .17 * Math.cos((hpbar - 30) * rad) + .24 * Math.cos(2 * hpbar * rad) + .32 * Math.cos((3 * hpbar + 6) * rad) - .20 * Math.cos((4 * hpbar - 63) * rad);
      const deltaTheta = 30 * Math.exp(-(((hpbar - 275) / 25) ** 2));
      const Rc = 2 * Math.sqrt(Cpbar ** 7 / (Cpbar ** 7 + 25 ** 7));
      const Sl = 1 + .015 * (Lbar - 50) ** 2 / Math.sqrt(20 + (Lbar - 50) ** 2);
      const Sc = 1 + .045 * Cpbar;
      const Sh = 1 + .015 * Cpbar * T;
      const Rt = -Math.sin(2 * deltaTheta * rad) * Rc;
      const l = dL / Sl;
      const c = dC / Sc;
      const h = dH / Sh;
      return Math.sqrt(l * l + c * c + h * h + Rt * c * h);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paint-thinner-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paint-thinner-stock-list')) {
  class PaintThinnerStockList extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      const availableList = this.querySelector('[data-thinner-available-list]');
      const unavailableSection = this.querySelector('[data-thinner-unavailable]');
      const unavailableList = this.querySelector('[data-thinner-unavailable-list]');
      const unavailableCount = this.querySelector('[data-thinner-unavailable-count]');

      if (!availableList || !unavailableSection || !unavailableList || !unavailableCount) return;

      const unavailableRows = Array.from(
        availableList.querySelectorAll('.paint-thinner__row--unavailable')
      );

      unavailableCount.textContent = unavailableRows.length.toString();

      if (unavailableRows.length > 0) {
        unavailableRows.forEach((row) => unavailableList.appendChild(row));
        unavailableSection.hidden = false;
      }

      this.dataset.initialized = 'true';
    }
  }

  customElements.define('paint-thinner-stock-list', PaintThinnerStockList);
}
  } catch(e) { console.error(e); }
})();

})();
